export default "__VITE_ASSET__Bls4ojM$__"